"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialFacilitiesModal = exports.FacilitiesModal = exports.default = void 0;

var _base = require("./base");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _noty = require("noty");

var _react = _interopRequireWildcard(require("react"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _decorators = require("decorators");

var _userProfile = require("user-profile");

var _logout = require("logout");

var _class, _descriptor, _descriptor2;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || babelHelpers.typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = babelHelpers.getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = babelHelpers.getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return babelHelpers.possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FacilitiesModal = /*#__PURE__*/function (_ReactModal) {
  babelHelpers.inherits(FacilitiesModal, _ReactModal);

  var _super = _createSuper(FacilitiesModal);

  function FacilitiesModal(id, init) {
    var _this;

    babelHelpers.classCallCheck(this, FacilitiesModal);
    _this = _super.call(this, id);
    _this.classList = ['modal', 'modal-full', 'modal-centered-content', 'fade'];
    _this.modalTitleElement = 'h3';
    _this.innerWrapper = false;
    _this.withError = false;
    _this.defaultType = null;
    _this.removeOnHide = true;
    _this.initialInstance = false;

    _this.setComponent( /*#__PURE__*/_react.default.createElement(Facilities, {
      modal: babelHelpers.assertThisInitialized(_this),
      init: init
    }));

    _this.initialInstance = init;
    return _this;
  }

  babelHelpers.createClass(FacilitiesModal, [{
    key: "title",
    get: function get() {
      return "";
    }
  }, {
    key: "show",
    value: function show() {
      var _this2 = this;

      if (this.initialInstance) {
        (0, _fetch.default)("data/cart/clients").then(function (v) {
          return v.json();
        }).then(function (v) {
          if (v.length != 1) {
            babelHelpers.get(babelHelpers.getPrototypeOf(FacilitiesModal.prototype), "show", _this2).call(_this2);
          }
        });
      } else {
        babelHelpers.get(babelHelpers.getPrototypeOf(FacilitiesModal.prototype), "show", this).call(this);
      }
    }
  }]);
  return FacilitiesModal;
}(_base.ReactModal);

exports.FacilitiesModal = FacilitiesModal;
var Facilities = (_class = /*#__PURE__*/function (_Component) {
  babelHelpers.inherits(Facilities, _Component);

  var _super2 = _createSuper(Facilities);

  function Facilities() {
    var _this3;

    babelHelpers.classCallCheck(this, Facilities);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this3 = _super2.call.apply(_super2, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this3, "modal", _descriptor, babelHelpers.assertThisInitialized(_this3));
    babelHelpers.initializerDefineProperty(_this3, "init", _descriptor2, babelHelpers.assertThisInitialized(_this3));
    _this3.state = {
      list: null
    };
    return _this3;
  }

  babelHelpers.createClass(Facilities, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;

      (0, _fetch.default)('data/cart/clients').then(function (v) {
        return v.json();
      }).then(function (v) {
        return _this4.setState({
          list: v
        });
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.state.list && this.state.list.length == 0) {
        (0, _logout.doLogout)();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      if (!this.state.list) return null;

      if (this.state.list.length == 0) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "overlay",
          id: "myNav"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "overlay-content"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "side-nav-main"
        }, /*#__PURE__*/_react.default.createElement("p", {
          style: {
            fontSize: 'calc(var(--scalable-unit) * 32 / 16)',
            color: '#fff'
          }
        }, "In order to sign into the ProSite, you must have a connection to at least one facility."), /*#__PURE__*/_react.default.createElement("p", {
          style: {
            fontSize: 'calc(var(--scalable-unit) * 32 / 16)',
            color: '#fff'
          }
        }, "Please contact us at ", /*#__PURE__*/_react.default.createElement("a", {
          href: "mailto:info@thepoolandspahouse.com"
        }, "info@thepoolandspahouse.com"), " and we'll fix this for you."))));
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "overlay",
        id: "myNav"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "overlay-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "side-nav-main"
      }, /*#__PURE__*/_react.default.createElement("h2", null, "Select a facility:"), /*#__PURE__*/_react.default.createElement("ul", null, this.state.list.map(function (_ref) {
        var id = _ref.id,
            name = _ref.name,
            selected = _ref.selected;
        return /*#__PURE__*/_react.default.createElement("li", {
          className: _classList.default.join('large-side-nav', !_this5.init && selected && 'active'),
          key: id
        }, /*#__PURE__*/_react.default.createElement("a", {
          href: "javascript:void(0)",
          onClick: _this5.selectClient,
          "data-client-id": id
        }, !_this5.init && selected ? /*#__PURE__*/_react.default.createElement("span", {
          style: {
            fontSize: '2em'
          }
        }, "\u2022") : null, /*#__PURE__*/_react.default.createElement("span", null, name)));
      })))));
    }
  }, {
    key: "selectClient",
    value: function selectClient(event) {
      var _this6 = this;

      var id = event.currentTarget.dataset.clientId;
      (0, _fetch.default)('data/cart/client', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: id
        })
      }).then(function (data) {
        return data.json();
      }).then(function (_ref2) {
        var name = _ref2.name;

        _this6.modal.hide();

        (0, _userProfile.userProfileUpdated)();

        require('components/SiteNavigation').default.clientUpdated();

        (0, _noty.showNotificationText)("Selected facility \"".concat(name, "\"."));
      });
    }
  }]);
  return Facilities;
}(_react.Component), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "modal", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "init", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "selectClient", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "selectClient"), _class.prototype)), _class);
var instance = new FacilitiesModal('facilities-modal', false);
var initInstance = new FacilitiesModal('facilities-modal', true);
exports.initialFacilitiesModal = initInstance;
var _default = instance;
exports.default = _default;